import type { PaginationItem } from "./index.types";

export const getPaginationItems = (currentPage: number, pageCount: number): PaginationItem[] => {
  if (pageCount <= 7) return Array.from({ length: pageCount }, (_, index) => index);

  const windowStart = Math.max(1, Math.min(currentPage - 1, pageCount - 4));
  const windowEnd = Math.min(pageCount - 2, windowStart + 2);
  const items: PaginationItem[] = [0];
  if (windowStart > 1) items.push("ellipsis-start");
  for (let page = windowStart; page <= windowEnd; page += 1) items.push(page);
  if (windowEnd < pageCount - 2) items.push("ellipsis-end");
  items.push(pageCount - 1);
  return items;
};
